(function () {
  "use strict";

  if (window.AmishGreenhouseBuilder) {
    window.AmishGreenhouseBuilder.scan();
    return;
  }

  var SIZES = [
    { key:"20x25", family:"backyard", width:20, length:25, backyard:3700, install:1900 },
    { key:"20x30", family:"backyard", width:20, length:30, backyard:3950, install:2000 },
    { key:"20x24", family:"professional", width:20, length:24, basic:3510, standard:4341, upgraded:7296, install:2000 },
    { key:"20x36", family:"professional", width:20, length:36, basic:4030, standard:5029, upgraded:7984, install:2400 },
    { key:"20x48", family:"professional", width:20, length:48, basic:4615, standard:5782, upgraded:8737, install:2880 },
    { key:"20x60", family:"professional", width:20, length:60, basic:5395, standard:6730, upgraded:9685, install:3600 },
    { key:"20x72", family:"professional", width:20, length:72, basic:6370, standard:7873, upgraded:10828, install:4320 },
    { key:"20x96", family:"professional", width:20, length:96, basic:7962, standard:9801, upgraded:12756, install:5760 },
    { key:"30x48", family:"professional", width:30, length:48, basic:7085, standard:8702, upgraded:12167, install:5040 },
    { key:"30x60", family:"professional", width:30, length:60, basic:7962, standard:9747, upgraded:13212, install:5400 },
    { key:"30x72", family:"professional", width:30, length:72, basic:9522, standard:11475, upgraded:14940, install:6480 },
    { key:"30x96", family:"professional", width:30, length:96, basic:11700, standard:13989, upgraded:17454, install:8640 },
    { key:"30x148", family:"professional", width:30, length:148, basic:15780, standard:18797, upgraded:22262, install:13320 },
    { key:"34x96", family:"professional", width:34, length:96, standard:15130, upgraded:18895, install:9792 },
    { key:"34x148", family:"professional", width:34, length:148, standard:21480, upgraded:25245, install:12580 },
    { key:"34x196", family:"professional", width:34, length:196, standard:26135, upgraded:29900, install:14700 }
  ];
  var PACKAGE_NAMES = { backyard:"Backyard", basic:"DIY Basic", standard:"Standard", upgraded:"Upgraded", custom:"Custom" };
  var SPECIAL_LOGISTICS = ["AK", "HI", "PR", "VI", "GU", "AS", "MP"];
  var instances = new Map();

  var PRICE_FACTOR = 1;
  function roundPrice(value) { return Math.round((Number(value) || 0) * PRICE_FACTOR / 5) * 5; }
  function money(value) {
    return new Intl.NumberFormat("en-US", { style:"currency", currency:"USD", maximumFractionDigits:0 }).format(Number(value) || 0);
  }
  function number(value) { return new Intl.NumberFormat("en-US").format(Math.round(Number(value) || 0)); }
  function esc(value) {
    return String(value == null ? "" : value).replace(/[&<>"']/g, function (char) {
      return { "&":"&amp;", "<":"&lt;", ">":"&gt;", "\"":"&quot;", "'":"&#39;" }[char];
    });
  }
  function setText(root, selector, value) {
    var el = root.querySelector(selector);
    if (el) el.textContent = value;
  }
  function setValue(root, selector, value) {
    var el = root.querySelector(selector);
    if (el) el.value = value;
  }
  function selectedSize(state) {
    return SIZES.find(function (size) { return size.key === state.size; }) || SIZES.find(function (size) { return size.key === "30x60"; });
  }
  function availableSizes(packageId) {
    return SIZES.filter(function (size) {
      if (packageId === "backyard") return size.family === "backyard";
      if (packageId === "basic") return size.family === "professional" && size.basic != null;
      return size.family === "professional";
    });
  }
  function calculate(state) {
    var size = selectedSize(state);
    var base;
    if (state.packageId === "backyard") base = size.backyard;
    else if (state.packageId === "basic") base = size.basic;
    else if (state.packageId === "upgraded") base = size.upgraded;
    else base = size.standard;
    base = roundPrice(base);
    var addons = 0;
    var upgraded = state.packageId === "upgraded";
    if (!upgraded && state.frontMaterial === "polycarbonate") addons += 750;
    if (!upgraded && state.backMaterial === "polycarbonate") addons += 750;
    if (!upgraded && (state.frontDoor === "sliding" || state.frontDoor === "rollup")) addons += 475;
    if (!upgraded && state.exhaustFan) addons += 410;
    if (state.heater && state.packageId === "backyard") addons += 1200;
    addons = roundPrice(addons);
    var install = state.installation ? roundPrice(size.install) : 0;
    var quoteItems = [
      state.sideOperator === "automatic",
      state.hafFans,
      state.controller,
      state.baseboard === "white-panel",
      size.length >= 148 && state.exhaustFan,
      state.heater && state.packageId !== "backyard",
      state.benches
    ].filter(Boolean).length;
    var usable = Math.round(size.width * size.length * 0.76);
    var trays = Math.floor(usable / (state.benches ? 6.2 : 11.5));
    return { base:base, addons:addons, kit:base + addons, install:install, total:base + addons + install, quoteItems:quoteItems, usable:usable, trays:trays, plugs:trays * 72 };
  }
  function configurationText(state) {
    var size = selectedSize(state);
    var parts = [
      size.width + "′ × " + size.length + "′ " + PACKAGE_NAMES[state.packageId] + " greenhouse",
      "double-wall 6 mil poly with inflation blower",
      state.frontMaterial + " front end / " + state.backMaterial + " rear end",
      "front access: " + state.frontDoor,
      "rear access: " + state.backDoor,
      state.baseboard + " baseboard",
      state.sideOperator + " roll-up sides at " + state.sideOpening + "%"
    ];
    if (state.exhaustFan) parts.push("24-inch exhaust fan");
    if (state.intakeShutter) parts.push("intake shutter");
    if (state.hafFans) parts.push("HAF circulation fans");
    if (state.heater) parts.push("overhead unit heater");
    if (state.controller) parts.push("temperature automation");
    if (state.benches) parts.push("propagation benches");
    parts.push(state.installation ? "builder installation requested" : "kit / owner installation");
    return parts.join("; ");
  }
  function jsonp(url, callbackParameter) {
    return new Promise(function (resolve, reject) {
      var callbackName = "agbJsonp" + Date.now() + Math.floor(Math.random() * 100000);
      var script = document.createElement("script");
      var timer = window.setTimeout(function () { cleanup(); reject(new Error("Lookup timed out")); }, 12000);
      function cleanup() {
        window.clearTimeout(timer);
        if (script.parentNode) script.parentNode.removeChild(script);
        try { delete window[callbackName]; } catch (error) { window[callbackName] = undefined; }
      }
      window[callbackName] = function (data) { cleanup(); resolve(data); };
      script.onerror = function () { cleanup(); reject(new Error("Lookup unavailable")); };
      script.src = url + (url.indexOf("?") >= 0 ? "&" : "?") + encodeURIComponent(callbackParameter || "callback") + "=" + encodeURIComponent(callbackName);
      document.head.appendChild(script);
    });
  }
  function censusLookup(address) {
    var url = "https://geocoding.geo.census.gov/geocoder/locations/onelineaddress?address=" + encodeURIComponent(address) + "&benchmark=Public_AR_Current&format=jsonp";
    return jsonp(url, "callback").then(function (data) {
      var match = data && data.result && data.result.addressMatches && data.result.addressMatches[0];
      if (!match) throw new Error("We could not match that physical address. Check the street, city, state and ZIP.");
      return {
        matchedAddress: match.matchedAddress || address,
        lat: Number(match.coordinates && match.coordinates.y),
        lng: Number(match.coordinates && match.coordinates.x),
        state: String(match.addressComponents && match.addressComponents.state || "").toUpperCase(),
        zip: String(match.addressComponents && match.addressComponents.zip || "").slice(0, 5)
      };
    });
  }
  function arcGisJson(url) {
    return fetch(url, { credentials:"omit" })
      .then(function (response) { if (!response.ok) throw new Error("Zone lookup failed"); return response.json(); })
      .catch(function () { return jsonp(url, "callback"); });
  }
  function zoneLookup(zip, lat, lng) {
    function zipLookup() {
      if (!/^\d{5}$/.test(zip)) return Promise.resolve({ zone:"", zoneClass:"Zone unavailable without a matched 5-digit ZIP" });
      var where = "ZIP_CODE = '" + zip + "'";
      var url = "https://services1.arcgis.com/SyUSN23vOoYdfLC8/arcgis/rest/services/PHZM_2023_Zip_Code_Table/FeatureServer/296/query?where=" + encodeURIComponent(where) + "&outFields=ZIP_CODE%2CZONE_CODE%2CClass%2CClass_Code&returnGeometry=false&f=json";
      return arcGisJson(url).then(function (data) {
          var attributes = data && data.features && data.features[0] && data.features[0].attributes;
          if (!attributes) return { zone:"", zoneClass:"USDA zone unavailable for this ZIP" };
          var zoneClass = String(attributes.Class || "");
          var zone = (zoneClass.match(/^\s*([0-9]{1,2}[ab]?)/i) || [])[1] || "";
          return { zone:zone, zoneClass:zoneClass || (zone ? "Zone " + zone : "") };
        });
    }
    if (!Number.isFinite(Number(lat)) || !Number.isFinite(Number(lng))) return zipLookup();
    var pointUrl = "https://services1.arcgis.com/SyUSN23vOoYdfLC8/arcgis/rest/services/PHZM_Links_with_zones/FeatureServer/6/query?geometry=" + encodeURIComponent(Number(lng) + "," + Number(lat)) + "&geometryType=esriGeometryPoint&inSR=4326&spatialRel=esriSpatialRelIntersects&outFields=ClassName%2CClassDesc&returnGeometry=false&f=json";
    return arcGisJson(pointUrl).then(function (data) {
      var attributes = data && data.features && data.features[0] && data.features[0].attributes;
      if (!attributes || !attributes.ClassName) return zipLookup();
      var zone = String(attributes.ClassName);
      var description = String(attributes.ClassDesc || "");
      return { zone:zone, zoneClass:description || ("Zone " + zone) };
    }).catch(zipLookup);
  }
  function proxyLookup(proxy, address) {
    var separator = proxy.indexOf("?") >= 0 ? "&" : "?";
    return fetch(proxy + separator + "address=" + encodeURIComponent(address), { headers:{ Accept:"application/json" }, credentials:"omit" })
      .then(function (response) { if (!response.ok) throw new Error("Estimate service unavailable"); return response.json(); });
  }
  function haversine(lat1, lng1, lat2, lng2) {
    var toRad = Math.PI / 180;
    var dLat = (lat2 - lat1) * toRad;
    var dLng = (lng2 - lng1) * toRad;
    var a = Math.sin(dLat / 2) ** 2 + Math.cos(lat1 * toRad) * Math.cos(lat2 * toRad) * Math.sin(dLng / 2) ** 2;
    return 3958.7613 * 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
  }
  function recommendationFor(zone) {
    var numeric = parseFloat(zone);
    if (!Number.isFinite(numeric)) return "A participating builder should verify the hardiness zone and crop setpoints before climate equipment is sized.";
    var base = "USDA zone reflects average annual extreme minimum temperature only. ";
    if (numeric <= 4) return base + "For winter production, prioritize double-wall inflated poly, a builder-sized heater, HAF circulation, automatic controls and backup temperature/power planning. Confirm design snow load and local code.";
    if (numeric <= 7) return base + "Double-wall inflated poly is recommended. Add a builder-sized heater and HAF circulation for winter growing, with automatic ventilation controls for shoulder seasons.";
    if (numeric <= 10) return base + "Prioritize roll-up sides, intake/exhaust ventilation, HAF circulation and automatic controls. Heat is crop- and season-specific; confirm the desired indoor setpoint with the builder.";
    return base + "Prioritize large natural-vent openings, HAF circulation and automatic roll-up sides, with powered ventilation and shade planning as needed. Heat is crop-specific.";
  }
  function travelRange(dispatchLat, dispatchLng, lat, lng) {
    var air = haversine(dispatchLat, dispatchLng, lat, lng);
    var central = air * 1.20;
    var margin = Math.max(25, central * 0.20);
    var rounding = central < 250 ? 10 : 25;
    var low = Math.max(air, central - margin);
    var high = central + margin;
    return { low:Math.max(rounding, Math.ceil(low / rounding) * rounding), high:Math.ceil(high / rounding) * rounding };
  }

  function createInstance(root) {
    var q = function (selector) { return root.querySelector(selector); };
    var qa = function (selector) { return Array.prototype.slice.call(root.querySelectorAll(selector)); };
    var state = {
      packageId:"upgraded", size:"30x60", view:"exterior",
      frontMaterial:"polycarbonate", backMaterial:"polycarbonate", frontDoor:"sliding", backDoor:"personnel",
      baseboard:"wood", curtainLock:true, sideOperator:"manual", sideOpening:38,
      exhaustFan:true, intakeShutter:true, hafFans:false, heater:false, controller:false, benches:true, installation:true
    };
    var location = null;
    var model = null;
    var modelLoadPromise = null;
    var previewTimer = 0;
    var observer = null;
    var destroyed = false;
    var cleanup = [];
    var dispatchLat = Number(root.dataset.dispatchLat) || 42.6028;
    var dispatchLng = Number(root.dataset.dispatchLng) || -85.0931;
    var fallbackDiesel = Number(root.dataset.dieselPrice) || 5.652;
    var fallbackDieselDate = root.dataset.dieselDate || "August 24, 2026";
    var proxy = (root.dataset.estimateProxy || "").trim();
    var marketUrl = (root.dataset.marketUrl || "").trim();
    if (marketUrl) {
      var sep = marketUrl.indexOf("?") === -1 ? "?" : "&";
      fetch(marketUrl + sep + "base=" + encodeURIComponent(root.dataset.priceBase || ""), { credentials:"omit", headers:{ Accept:"application/json" } })
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (m) {
          if (!m || destroyed) return;
          if (Number(m.dieselPrice) > 0) {
            fallbackDiesel = Number(m.dieselPrice);
            fallbackDieselDate = m.dieselDate || fallbackDieselDate;
            setText(root, "[data-fuel-ref-price]", fallbackDiesel.toFixed(3));
            setText(root, "[data-fuel-ref-date]", fallbackDieselDate);
          }
          if (Number(m.priceFactor) > 0) PRICE_FACTOR = Math.max(1, Math.min(1.35, Number(m.priceFactor)));
          var note = root.querySelector("[data-price-note]");
          if (note && m.priceNote) { note.textContent = m.priceNote; note.hidden = false; }
          render();
        })
        .catch(function () {});
    }
    var reportId = "AGB-" + new Date().toISOString().slice(0, 10).replace(/-/g, "") + "-" + Math.random().toString(36).slice(2, 6).toUpperCase();

    function on(target, eventName, handler) {
      if (!target) return;
      target.addEventListener(eventName, handler);
      cleanup.push(function () { target.removeEventListener(eventName, handler); });
    }
    function control(name) { return q('[data-setting="' + name + '"]'); }
    function writeControl(name, value) {
      var el = control(name);
      if (!el) return;
      if (el.type === "checkbox") el.checked = Boolean(value);
      else el.value = String(value);
    }
    function applyPackageDefaults(packageId) {
      if (packageId === "backyard") Object.assign(state, { size:"20x25", frontMaterial:"poly", backMaterial:"poly", frontDoor:"personnel", backDoor:"none", baseboard:"wood", curtainLock:true, sideOperator:"manual", exhaustFan:false, intakeShutter:false, hafFans:false, heater:false, controller:false });
      else if (packageId === "basic") Object.assign(state, { size:"20x48", frontMaterial:"open", backMaterial:"open", frontDoor:"none", backDoor:"none", baseboard:"none", curtainLock:false, sideOperator:"manual", exhaustFan:false, intakeShutter:false, hafFans:false, heater:false, controller:false });
      else if (packageId === "standard") Object.assign(state, { size:"30x60", frontMaterial:"poly", backMaterial:"poly", frontDoor:"personnel", backDoor:"none", baseboard:"wood", curtainLock:true, sideOperator:"manual", exhaustFan:false, intakeShutter:false, hafFans:false, heater:false, controller:false });
      else Object.assign(state, { size:"30x60", frontMaterial:"polycarbonate", backMaterial:"polycarbonate", frontDoor:"sliding", backDoor:"personnel", baseboard:"wood", curtainLock:true, sideOperator:"manual", exhaustFan:true, intakeShutter:true, hafFans:false, heater:false, controller:false });
      state.packageId = packageId;
      ["frontMaterial", "backMaterial", "frontDoor", "backDoor", "baseboard", "curtainLock", "sideOperator", "exhaustFan", "intakeShutter", "hafFans", "heater", "controller"].forEach(function (key) { writeControl(key, state[key]); });
      populateSizes();
    }
    function populateSizes() {
      var select = control("size");
      var allowed = availableSizes(state.packageId);
      if (!allowed.some(function (size) { return size.key === state.size; })) state.size = allowed[0].key;
      select.innerHTML = allowed.map(function (size) { return '<option value="' + size.key + '">' + size.width + "′ × " + size.length + "′ · " + number(size.width * size.length) + " sq. ft.</option>"; }).join("");
      select.value = state.size;
    }
    function readSetting(el) {
      var key = el.dataset.setting;
      var value = el.type === "checkbox" ? el.checked : el.type === "range" ? Number(el.value) : el.value;
      state[key] = value;
      if (key === "sideOperator" && value === "automatic") { state.controller = true; writeControl("controller", true); }
      if (key === "exhaustFan" && value) {
        state.intakeShutter = true; state.frontMaterial = "polycarbonate"; state.backMaterial = "polycarbonate";
        writeControl("intakeShutter", true); writeControl("frontMaterial", "polycarbonate"); writeControl("backMaterial", "polycarbonate");
      }
      if (key === "intakeShutter" && value) { state.frontMaterial = "polycarbonate"; writeControl("frontMaterial", "polycarbonate"); }
      if (key === "frontMaterial" && value === "open") { state.intakeShutter = false; writeControl("intakeShutter", false); }
      if (key === "backMaterial" && value === "open") { state.exhaustFan = false; writeControl("exhaustFan", false); }
      if (key === "baseboard" && value === "none") { state.curtainLock = false; writeControl("curtainLock", false); }
      render();
    }
    function renderWarnings() {
      var size = selectedSize(state);
      var warnings = [];
      if (state.exhaustFan && state.sideOpening > 20) warnings.push("Powered exhaust control requires roll-up sides to close first; the current preview is in natural-vent mode.");
      if (state.heater && !state.hafFans) warnings.push("Add HAF circulation to distribute heat and reduce hot and cold zones.");
      if (size.length >= 148 && state.exhaustFan) warnings.push("A 148′+ house needs engineered fan and intake sizing; one fan is shown only as a placement reference.");
      q("[data-warnings]").innerHTML = warnings.map(function (warning) { return '<div class="agb-alert agb-alert--warning"><b>Planning note:</b> ' + esc(warning) + "</div>"; }).join("");
    }
    function render() {
      if (destroyed) return;
      var size = selectedSize(state);
      var calc = calculate(state);
      var config = configurationText(state);
      setText(root, "[data-frame-spec]", size.width >= 34 ? "2⅜″ · 16 ga" : "2″ · 13 ga");
      setText(root, "[data-bow-spacing]", state.packageId === "backyard" ? "5′" : "4′");
      setText(root, "[data-opening-output]", state.sideOpening + "%");
      setText(root, "[data-install-price]", money(roundPrice(size.install)) + " planning figure");
      setText(root, "[data-series]", state.packageId === "backyard" ? "Backyard grower series" : "Professional grower series");
      setText(root, "[data-model-title]", "Your " + size.width + "′ × " + size.length + "′ " + PACKAGE_NAMES[state.packageId] + " greenhouse");
      setText(root, "[data-budget-total]", money(calc.total));
      setText(root, "[data-price-base]", money(calc.base));
      setText(root, "[data-price-addons]", money(calc.addons));
      q("[data-addons-row]").hidden = calc.addons === 0;
      setText(root, "[data-price-install]", money(calc.install));
      setText(root, "[data-price-total]", money(calc.total));
      setText(root, "[data-usable-area]", number(calc.usable));
      setText(root, "[data-trays]", number(calc.trays));
      setText(root, "[data-plugs]", number(calc.plugs));
      var quote = q("[data-quote-items]");
      quote.hidden = calc.quoteItems === 0;
      quote.innerHTML = "<b>" + calc.quoteItems + " selection" + (calc.quoteItems === 1 ? "" : "s") + " need builder pricing.</b> They are shown in 3D but not added to this planning total.";
      q("[data-system-pills]").innerHTML = [
        "Double-wall poly", "Inflation blower", (state.sideOperator === "manual" ? "Hand-crank" : "Automatic") + " sides · " + state.sideOpening + "%",
        state.exhaustFan ? "Exhaust fan" : "", state.intakeShutter ? "Intake shutter" : "", state.heater ? "Overhead heat" : "", state.hafFans ? "HAF racetrack" : "", state.controller ? "Climate control" : ""
      ].filter(Boolean).map(function (text) { return "<span>" + esc(text) + "</span>"; }).join("");
      control("curtainLock").disabled = state.baseboard === "none";
      control("controller").disabled = state.sideOperator === "automatic";
      control("intakeShutter").disabled = state.exhaustFan;
      renderWarnings();
      setValue(root, "[data-hidden-config]", config);
      setValue(root, "[data-hidden-budget]", money(calc.total) + " before travel; planning estimate only");
      setText(root, "[data-print-config]", config);
      setText(root, "[data-print-budget]", money(calc.total) + " before travel");
      setText(root, "[data-print-quote]", calc.quoteItems + " selection" + (calc.quoteItems === 1 ? "" : "s") + " require builder pricing");
      if (model && model.update) {
        model.update(Object.assign({}, state, { width:size.width, length:size.length, bowSpacing:state.packageId === "backyard" ? 5 : 4 }));
        schedulePreviewCapture();
      }
    }
    function updateReportContact() {
      var form = q(".agb-contact-form");
      if (!form) return;
      var name = form.querySelector('[name="contact[name]"]');
      var email = form.querySelector('[name="contact[email]"]');
      var phone = form.querySelector('[name="contact[phone]"]');
      var address = q("[data-project-address]");
      setText(root, "[data-print-name]", name && name.value.trim() || "—");
      setText(root, "[data-print-email]", email && email.value.trim() || "—");
      setText(root, "[data-print-phone]", phone && phone.value.trim() || "—");
      setText(root, "[data-print-address]", address && address.value.trim() || "—");
    }
    function locationSuccess(data) {
      var range = travelRange(dispatchLat, dispatchLng, Number(data.lat), Number(data.lng));
      var special = SPECIAL_LOGISTICS.indexOf(String(data.state || "").toUpperCase()) >= 0;
      var diesel = Number(data.dieselPrice) || fallbackDiesel;
      var dieselDate = data.dieselDate || fallbackDieselDate;
      var zone = data.zone || "";
      var zoneClass = data.zoneClass || (zone ? "Zone " + zone : "Zone unavailable");
      var recommendations = recommendationFor(zone);
      var lowFuel = Math.round(range.low * 2 / 12 * diesel);
      var highFuel = Math.round(range.high * 2 / 8 * diesel);
      location = {
        matchedAddress:data.matchedAddress, state:data.state, zip:data.zip, zone:zone, zoneClass:zoneClass, recommendations:recommendations,
        lowMiles:range.low, highMiles:range.high, lowFuel:lowFuel, highFuel:highFuel, diesel:diesel, dieselDate:dieselDate, special:special
      };
      var result = q("[data-location-result]");
      result.hidden = false;
      result.dataset.state = "success";
      var travelText = special ? "Special travel/logistics estimate required" : range.low + "–" + range.high + " miles one way";
      var fuelText = special ? "Builder review required" : money(lowFuel) + "–" + money(highFuel) + " fuel-only round trip";
      result.innerHTML = '<strong>Preliminary address planning record</strong><span>' + esc(data.matchedAddress) + '</span><dl><div><dt>One-way travel</dt><dd>' + esc(travelText) + '</dd></div><div><dt>Fuel-only estimate</dt><dd>' + esc(fuelText) + '</dd></div><div><dt>Fuel reference</dt><dd>$' + diesel.toFixed(3) + "/gal diesel · " + esc(dieselDate) + '</dd></div><div><dt>USDA 2023 hardiness</dt><dd>' + esc(zoneClass) + '</dd></div></dl><p><b>Recommendation:</b> ' + esc(recommendations) + '</p><p><b>Estimate for your records only.</b> Mileage is a planning range, not a route or travel charge. Fuel-only range assumes 8–12 mpg and excludes labor, vehicle wear, tolls, lodging, ferries, crew expenses and site access. The participating builder confirms all travel charges.</p>';
      setValue(root, "[data-hidden-matched-address]", data.matchedAddress);
      setValue(root, "[data-hidden-travel]", travelText + "; preliminary one-way planning range");
      setValue(root, "[data-hidden-fuel]", fuelText + "; diesel $" + diesel.toFixed(3) + "/gal dated " + dieselDate + "; estimate for records only");
      setValue(root, "[data-hidden-zone]", zoneClass);
      setValue(root, "[data-hidden-recommendations]", recommendations);
      setText(root, "[data-print-matched]", data.matchedAddress);
      setText(root, "[data-print-zone]", zoneClass);
      setText(root, "[data-print-travel]", travelText);
      setText(root, "[data-print-fuel]", fuelText + " at $" + diesel.toFixed(3) + "/gal diesel (" + dieselDate + ")");
      setText(root, "[data-print-recommendations]", recommendations);
    }
    function locationError(error) {
      clearLocation();
      var result = q("[data-location-result]");
      result.hidden = false;
      result.dataset.state = "error";
      result.innerHTML = "<strong>We could not calculate this address.</strong><span>" + esc(error && error.message || "Check the full physical street address and try again.") + " You can still submit the design; a participating builder or coordinator will verify travel and hardiness details.</span>";
    }
    function clearLocation() {
      location = null;
      setValue(root, "[data-hidden-matched-address]", "");
      setValue(root, "[data-hidden-travel]", "");
      setValue(root, "[data-hidden-fuel]", "");
      setValue(root, "[data-hidden-zone]", "");
      setValue(root, "[data-hidden-recommendations]", "");
      setText(root, "[data-print-matched]", "Not calculated");
      setText(root, "[data-print-zone]", "Not calculated");
      setText(root, "[data-print-travel]", "Not calculated");
      setText(root, "[data-print-fuel]", "Not calculated");
      setText(root, "[data-print-recommendations]", "Enter the project address and calculate the hardiness zone to add recommendations.");
      q("[data-location-result]").hidden = true;
    }
    function calculateLocation() {
      var input = q("[data-project-address]");
      var button = q("[data-calculate-location]");
      var address = input.value.trim();
      if (!address) { input.reportValidity(); return; }
      button.disabled = true;
      button.textContent = "Calculating…";
      var task;
      if (proxy) {
        task = proxyLookup(proxy, address).then(function (data) {
          if (!data || !Number.isFinite(Number(data.lat)) || !Number.isFinite(Number(data.lng))) throw new Error("The estimate service did not return a matched location.");
          if (data.zone || data.zoneClass || !data.zip) return data;
          return zoneLookup(String(data.zip).slice(0, 5), data.lat, data.lng).then(function (zone) { return Object.assign(data, zone); });
        });
      } else {
        task = censusLookup(address).then(function (data) { return zoneLookup(data.zip, data.lat, data.lng).then(function (zone) { return Object.assign(data, zone); }); });
      }
      task.then(locationSuccess).catch(locationError).finally(function () { button.disabled = false; button.textContent = "Calculate travel & hardiness zone"; });
    }
    function applyPreviewImage(dataUrl) {
      if (!dataUrl) return false;
      [q("[data-form-preview-image]"), q("[data-print-preview-image]")].forEach(function (image) {
        if (!image) return;
        image.src = dataUrl;
        image.hidden = false;
      });
      [q("[data-form-preview-empty]"), q("[data-print-preview-empty]")].forEach(function (empty) {
        if (empty) empty.hidden = true;
      });
      setText(root, "[data-preview-status]", "Screenshot updated from the current 3D view.");
      return true;
    }
    var shotOptions = { angle:"front34", zoom:1 };
    function applyViews(urls) {
      var names = ["front", "rear", "left", "right"];
      if (!urls || !urls.length) return;
      names.forEach(function (name, i) {
        Array.prototype.forEach.call(root.querySelectorAll('[data-view-img="' + name + '"],[data-print-view-img="' + name + '"]'), function (img) { if (urls[i]) img.src = urls[i]; });
      });
      Array.prototype.forEach.call(root.querySelectorAll("[data-views]"), function (el) { el.hidden = false; });
    }
    function capturePreviewNow() {
      if (!model || !model.captureScreenshot) return false;
      try { var shotOk = applyPreviewImage(model.captureScreenshot(shotOptions)); applyViews(model.captureScreenshot({ angles:["front", "rear", "left", "right"] })); return shotOk; }
      catch (error) { return false; }
    }
    function capturePreview(options) {
      options = options || {};
      if (destroyed) return Promise.resolve(false);
      if (previewTimer) { clearTimeout(previewTimer); previewTimer = 0; }
      var button = q("[data-refresh-preview]");
      if (button) { button.disabled = true; button.textContent = "Capturing…"; }
      if (!options.silent) setText(root, "[data-preview-status]", "Capturing the current 3D view…");
      return Promise.resolve(loadModel()).then(function () {
        if (!model || !model.captureScreenshot) throw new Error("The 3D preview is unavailable.");
        return new Promise(function (resolve) {
          requestAnimationFrame(function () { requestAnimationFrame(resolve); });
        });
      }).then(function () {
        if (!capturePreviewNow()) throw new Error("The browser could not capture the 3D view.");
        return true;
      }).catch(function () {
        var image = q("[data-form-preview-image]");
        var empty = q("[data-form-preview-empty]");
        if ((!image || image.hidden) && empty) {
          empty.hidden = false;
          empty.textContent = "The 3D screenshot is unavailable in this browser. The rest of the request and printable sheet still work.";
        }
        setText(root, "[data-preview-status]", "Screenshot unavailable. You can still submit or print the request.");
        return false;
      }).finally(function () {
        if (button) { button.disabled = false; button.textContent = "Refresh screenshot"; }
      });
    }
    function schedulePreviewCapture() {
      if (destroyed || !model) return;
      if (previewTimer) clearTimeout(previewTimer);
      setText(root, "[data-preview-status]", "Design changed. Updating the screenshot…");
      previewTimer = setTimeout(function () { previewTimer = 0; capturePreview({ silent:true }); }, 350);
    }
    function gllfLoadModules(threeUrl, modelUrl) {
      return new Promise(function (resolve, reject) {
        var key = "__gllfGreenhouse" + Date.now();
        var abs = function (u) { return new URL(u, window.location.href).href; };
        var s = document.createElement("script");
        s.type = "module";
        s.textContent = "import * as T from " + JSON.stringify(abs(threeUrl)) + "; import * as M from " + JSON.stringify(abs(modelUrl)) + "; window[" + JSON.stringify(key) + "] = { three: T, model: M }; window.dispatchEvent(new Event(" + JSON.stringify(key) + "));";
        var timer = setTimeout(function () { reject(new Error("3D modules timed out")); }, 20000);
        window.addEventListener(key, function () { clearTimeout(timer); resolve(window[key]); delete window[key]; }, { once: true });
        s.onerror = function () { clearTimeout(timer); reject(new Error("3D modules failed to load")); };
        document.head.appendChild(s);
      });
    }
    function loadModel() {
      if (destroyed) return Promise.resolve(null);
      if (model) return model.ready ? model.ready.then(function () { return model; }) : Promise.resolve(model);
      if (modelLoadPromise) return modelLoadPromise;
      var stage = q("[data-3d-stage]");
      modelLoadPromise = gllfLoadModules(root.dataset.threeUrl, root.dataset.modelUrl).then(function (mods) { var module = mods.model;
        if (destroyed) return null;
        var size = selectedSize(state);
        model = module.initGreenhouse3D(stage, Object.assign({}, state, { width:size.width, length:size.length, bowSpacing:state.packageId === "backyard" ? 5 : 4 }), { threeUrl:root.dataset.threeUrl, THREE:mods.three });
        return model.ready;
      }).then(function () {
        if (destroyed || !model) return null;
/* gllf-fix-e50482ca7371 */        stage.dataset.ready = "true";
        var canvas = stage.querySelector("canvas");
        on(canvas, "webglcontextlost", function () {
          var lost = model;
          model = null;
          if (lost && lost.destroy) { try { lost.destroy(); } catch (error) {} }
          var placeholder = stage.querySelector(".agb-stage-placeholder");
          if (placeholder) placeholder.innerHTML = "<b>3D preview unavailable</b><small>The configurator, estimate, contact form and printable report are still available.</small>";
        });
        setTimeout(function () { capturePreview({ silent:true }); }, 0);
        return model;
      }).catch(function (err) {
        if (destroyed) return null;
        console.error("[GLLF greenhouse 3D]", err);
        stage.querySelector(".agb-stage-placeholder").innerHTML = "<b>3D preview unavailable</b><small>The configurator, estimate, contact form and printable report are still available.</small>";
        return null;
      });
      return modelLoadPromise;
    }

    qa('[data-package-options] input[type="radio"]').forEach(function (radio) {
      on(radio, "change", function () { if (radio.checked) { applyPackageDefaults(radio.value); render(); } });
    });
    qa("[data-setting]").forEach(function (el) { on(el, "change", function () { readSetting(el); }); on(el, "input", function () { if (el.type === "range") readSetting(el); }); });
    qa("[data-view-tabs] button").forEach(function (button) {
      on(button, "click", function () {
        state.view = button.dataset.view;
        qa("[data-view-tabs] button").forEach(function (item) { item.setAttribute("aria-pressed", String(item === button)); });
        render();
      });
    });
    on(q("[data-calculate-location]"), "click", calculateLocation);
    on(q("[data-refresh-preview]"), "click", function () { capturePreview(); });
    Array.prototype.forEach.call(root.querySelectorAll("[data-shot]"), function (btn) {
      btn.addEventListener("click", function () {
        shotOptions.angle = btn.dataset.shot;
        Array.prototype.forEach.call(root.querySelectorAll("[data-shot]"), function (x) { x.setAttribute("aria-pressed", String(x === btn)); });
        Promise.resolve(capturePreview()).then(function () {
          if (shotOptions.angle === "current") setText(root, "[data-preview-status]", "Using your view. Turn the 3D model, then press Refresh screenshot.");
        });
      });
    });
    var zoomInput = q("[data-shot-zoom]");
    if (zoomInput) zoomInput.addEventListener("input", function () { shotOptions.zoom = Number(zoomInput.value) || 1; schedulePreviewCapture(); });
    on(q("[data-project-address]"), "input", function () { clearLocation(); updateReportContact(); });
    qa('.agb-contact-form input, .agb-contact-form textarea').forEach(function (input) { on(input, "input", updateReportContact); });
    on(q("[data-print-builder]"), "click", function () {
      updateReportContact();
      render();
      capturePreview({ silent:true }).then(function () { window.print(); });
    });
    on(window, "beforeprint", function () { updateReportContact(); render(); capturePreviewNow(); });
    setText(root, "[data-print-id]", reportId);
    setText(root, "[data-print-date]", new Intl.DateTimeFormat("en-US", { dateStyle:"long" }).format(new Date()));
    populateSizes();
    render();
    updateReportContact();

    if ("IntersectionObserver" in window) {
      observer = new IntersectionObserver(function (entries) {
        if (entries.some(function (entry) { return entry.isIntersecting; })) { observer.disconnect(); loadModel(); }
      }, { rootMargin:"280px" });
      observer.observe(q("[data-3d-stage]"));
    } else loadModel();

    return {
      destroy:function () {
        destroyed = true;
        if (previewTimer) clearTimeout(previewTimer);
        cleanup.forEach(function (fn) { fn(); });
        if (observer) observer.disconnect();
        if (model && model.destroy) model.destroy();
      }
    };
  }

  function scan(scope) {
    var context = scope || document;
    var roots = [];
    if (context.matches && context.matches("[data-agb-root]")) roots.push(context);
    roots = roots.concat(Array.prototype.slice.call(context.querySelectorAll ? context.querySelectorAll("[data-agb-root]") : []));
    roots.forEach(function (root) {
      if (instances.has(root)) return;
      instances.set(root, createInstance(root));
    });
  }
  function unload(scope) {
    var root = scope && scope.matches && scope.matches("[data-agb-root]") ? scope : scope && scope.querySelector && scope.querySelector("[data-agb-root]");
    if (root && instances.has(root)) { instances.get(root).destroy(); instances.delete(root); }
  }

  window.AmishGreenhouseBuilder = { scan:scan, unload:unload };
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", function () { scan(document); });
  else scan(document);
  document.addEventListener("shopify:section:load", function (event) { scan(event.target); });
  document.addEventListener("shopify:section:unload", function (event) { unload(event.target); });
})();
